function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M57,36h-6v-8c0-6.07-4.93-11-11-11s-11,4.93-11,11v8h-6v-8c0-9.37,7.63-17,17-17s17,7.63,17,17v8Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,69c-9.37,0-17-7.63-17-17v-8h6v8c0,6.07,4.93,11,11,11s11-4.93,11-11v-8h6v8c0,9.37-7.63,17-17,17Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 37,
  y: 27,
  width: 6,
  height: 28
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/Relevance-inactive.98a6de75.svg";
export { SvgComponent as ReactComponent };